<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('faqs.edit', { id: vm.$route.params.faqsId })
  }),
  computed: {
    ...mapState('faqs', ['routeKey', 'routes', 'form', 'item']),
    crumbs: vm => [
      { text: vm.$t('faqs.title'), to: { name: 'faqs.index' } },
      { text: vm.$t('faqs.edit', { id: vm.$route.params.faqsId }) }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('faqs/fetchItem', { route: to })
      await store.dispatch('faqs/fetchCategories')
      await store.dispatch('faqs/fetchSiteVersions')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('faqs', ['createItem', 'updateItem'])
  }
}
</script>
